import { createContext, useEffect, useState } from "react";

// import io from "socket.io-client";

export const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [searchInput, setSearchInput] = useState("");
  const [zohoIdFilter, setZohoIdFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [prjTypeFilter, setPrjTypeFilter] = useState("");
  const [regionFilter, setRegionFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [industryFilter, setIndustryFilter] = useState("");
  const [ownerFilter, setOwnerFilter] = useState("");
  const [filterPage, setFilterPage] = useState(1);
  const [filterUsed, setFilterUsed] = useState(false);

  return (
    <FilterContext.Provider
      value={{
        searchInput,
        setSearchInput,
        zohoIdFilter,
        setZohoIdFilter,
        statusFilter,
        setStatusFilter,
        prjTypeFilter,
        setPrjTypeFilter,
        regionFilter,
        setRegionFilter,
        countryFilter,
        setCountryFilter,
        industryFilter,
        setIndustryFilter,
        ownerFilter,
        setOwnerFilter,
        filterPage,
        setFilterPage,
        filterUsed,
        setFilterUsed,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
